import styled from "styled-components";

import { FONT_SIZES, SPACING } from "../../../../../utils/constants";

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
  margin-bottom: ${SPACING.lg}px;
`;

export const FieldsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: ${SPACING.md}px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs}px;
  min-width: 180px;
  flex: 1;
`;

export const FieldLabel = styled.label`
  font-size: ${FONT_SIZES.sm};
  color: var(--color-text-secondary);
`;

export const Actions = styled.div`
  display: flex;
  gap: ${SPACING.sm}px;
`;
